import container from "./HeadContainer";
export default container;

import MetaTags from "./MetaTags";
export { MetaTags };



// WEBPACK FOOTER //
// ./src/head/index.ts